import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Products } from "./components/Products";
import { Gallery } from "./components/gallery";
import { Brands } from "./components/brands";
import { Offers } from "./components/offers";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
  offset: 100,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  // ── Fix: dynamic header offset (marquee + navbar height) ──
  useEffect(() => {
    function setHeaderOffset() {
      const marquee = document.querySelector(".offer-marquee");
      const navbar = document.querySelector("#menu");
      const marqueeHeight = marquee ? marquee.offsetHeight : 0;
      const navbarHeight = navbar ? navbar.offsetHeight : 0;

      document.documentElement.style.setProperty(
        "--marquee-height",
        `${marqueeHeight}px`
      );
      document.documentElement.style.setProperty(
        "--header-offset",
        `${marqueeHeight + navbarHeight}px`
      );
    }

    setHeaderOffset();
    window.addEventListener("resize", setHeaderOffset);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setHeaderOffset);
    }

    const t = setTimeout(setHeaderOffset, 300);

    return () => {
      window.removeEventListener("resize", setHeaderOffset);
      clearTimeout(t);
    };
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <Products data={landingPageData.Products} />
      <Brands data={landingPageData.Brands} />
      <Gallery data={landingPageData.Gallery} />
      <Offers data={landingPageData.Offers} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;